// extracted by mini-css-extract-plugin
export default {"addButton":"teacher-cta_addButton__pu-2U"};